import React from 'react';

import { DateRangeFormatter, rangePresets } from '@gogame/intl-ts';

import { PERIOD } from 'scenes/Annotations/constants';

import { useCreateAnnotation, useUpdateAnnotation } from '../../data';
import AnnotationForm from './AnnotationForm';

export const AnnotationFormCreate = ({ onClose, onExited, open }) => {
  const [createAnnotation, { isLoading: isCreating }] = useCreateAnnotation();

  const handleSubmit = async (values) => {
    await createAnnotation(values);
    onClose();
  };

  return (
    <AnnotationForm
      title={'Add Annotation'}
      initialValues={{
        [PERIOD]: rangePresets.TODAY.value,
      }}
      loading={isCreating}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const AnnotationFormEdit = ({
  annotation,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [updateAnnotation, { isLoading: isUpdating }] = useUpdateAnnotation();
  const handleSubmit = async (values) => {
    await updateAnnotation(values);
    onSubmit();
  };

  return (
    <AnnotationForm
      title={'Edit Annotation'}
      subTitle={
        <DateRangeFormatter value={annotation?.[PERIOD]} template={'LL'} />
      }
      entityId={annotation?.id}
      active={annotation !== null}
      initialValues={annotation}
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={isUpdating}
      onExited={onExited}
      open={open}
    />
  );
};
